<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <div class="contentArea">
      <base-dialog :show="successModal" small>
        <div class="success my-10">
          <img src="../assets/success.svg" alt="" />
          <h2 class="mt-10 text-white">{{ successText }}</h2>
        </div>
      </base-dialog>
      <form @submit.prevent="submitForm">
        <h2 class="mb-5">ข้อมูลสมาชิก</h2>
        <div class="card">
          <div class="grid grid-cols-12 gap-5">
            <p class="col-span-2">ชื่อธุรกิจ :</p>
            <input
              tabindex="1"
              class="col-span-4 w-10/12"
              type="text"
              v-model="company_name"
              required
            />
            <p class="col-span-2 row-span-2">ที่อยู่:</p>
            <textarea
              rows="3"
              class="col-span-4 row-span-2"
              v-model="address"
              placeholder="ที่อยู่"
              required
            />
            <p class="col-span-2">รหัสบริษัท :</p>
            <input
              tabindex="2"
              class="col-span-4 w-10/12"
              type="text"
              placeholder="4 หลัก"
              v-model="company_code"
              minlength="4"
              maxlength="4"
              required
            />
            <p class="col-span-2">เลขประจำตัวผู้เสียภาษี :</p>
            <input
              tabindex="3"
              class="col-span-4 w-10/12"
              type="text"
              v-model="tax_id"
              required
            />
            <p class="col-span-2">ตำบล/แขวง :</p>
            <input
              class="col-span-4"
              type="text"
              v-model="subdistrict"
              required
            />
            <p class="col-span-2">สำนักงาน/สาขา :</p>
            <div class="col-span-4">
              <vs-radio
                tabindex="-1"
                v-model="headquarter"
                vs-value="true"
                color="#03a9f3"
                class="mr-10"
              >
                <p>สำนักงานใหญ่</p>
              </vs-radio>
              <vs-radio
                tabindex="-1"
                v-model="headquarter"
                vs-value="false"
                color="#03a9f3"
              >
                <p>สาขา</p>
              </vs-radio>
            </div>
            <p class="col-span-2">อำเภอ/เขต :</p>
            <input class="col-span-4" type="text" v-model="district" required />
            <div class="col-span-2"></div>
            <div class="col-span-4 w-10/12">
              <div class="grid grid-cols-10 gap-x-2">
                <input
                  tabindex="4"
                  class="col-span-4"
                  type="text"
                  placeholder="รหัสสาขา"
                  :disabled="headquarter === 'true' || headquarter === ''"
                  v-model="branch_code"
                  :required="headquarter === 'false'"
                />
                <input
                  tabindex="5"
                  class="col-span-6"
                  type="text"
                  placeholder="ชื่อสาขา"
                  :disabled="headquarter === 'true' || headquarter === ''"
                  v-model="branch_name"
                  :required="headquarter === 'false'"
                />
              </div>
            </div>
            <p class="col-span-2">จังหวัด :</p>
            <select
              tabindex="-1"
              class="col-span-4"
              v-model="province"
              required
            >
              <option
                v-for="province in thaiProvince"
                :key="province"
                :value="province"
                >{{ province }}</option
              >
            </select>
            <p class="col-span-2">เบอร์ติดต่อ :</p>
            <input
              tabindex="6"
              class="col-span-4 w-10/12"
              type="text"
              v-model="com_phone"
              required
            />
            <p class="col-span-2 col-start-7">รหัสไปรษณีย์ :</p>
            <input
              class="col-span-4"
              type="number"
              v-model.number="postcode"
              required
            />
            <p class="col-span-2 row-span-2">อีเมล :</p>
            <input
              tabindex="7"
              class="col-span-4 w-10/12"
              type="email"
              v-model="com_email"
              required
            />
            <p class="col-span-2 row-span-3">ที่อยู่จัดส่งเอกสาร :</p>
            <div class="col-span-4">
              <vs-checkbox tabindex="-1" color="#03a9f3" v-model="sameAddress"
                ><p>ใช้ที่อยู่เดียวกัน</p></vs-checkbox
              >
            </div>
            <textarea
              rows="3"
              class="col-span-4 row-span-2 col-end-13"
              placeholder="ที่อยู่"
              v-model="doc_address"
              :disabled="sameAddress"
            />
            <p class="col-span-2 col-start-1">ชื่อผู้ติดต่อ :</p>
            <input
              tabindex="8"
              class="col-span-4 w-10/12"
              type="text"
              v-model="contact_name"
            />
            <p class="col-span-2">อีเมล :</p>
            <input
              tabindex="9"
              class="col-span-4 w-10/12"
              type="email"
              v-model="contact_email"
            />
            <p class="col-span-2">ตำบล/แขวง :</p>
            <input
              class="col-span-4"
              type="text"
              v-model="doc_subdistrict"
              :disabled="sameAddress"
            />
            <p class="col-span-2">เบอร์โทรศัพท์ :</p>
            <input
              tabindex="10"
              class="col-span-4 w-10/12"
              type="text"
              v-model="contact_phone"
            />
            <p class="col-span-2">อำเภอ/เขต :</p>
            <input
              class="col-span-4"
              type="text"
              v-model="doc_district"
              :disabled="sameAddress"
            />
            <div class="col-span-6"></div>
            <p class="col-span-2">จังหวัด :</p>
            <select
              class="col-span-4"
              v-model="doc_province"
              :disabled="sameAddress"
            >
              <option
                v-for="province in thaiProvince"
                :key="province"
                :value="province"
                >{{ province }}</option
              >
            </select>
            <p class="col-span-2">ผู้รับเงิน :</p>
            <div class="col-span-4" style="position: relative;">
              <select
                tabindex="-1"
                class="w-10/12"
                v-model="accounting_id"
                required
              >
                <option
                  v-for="account in accountingList"
                  :key="account.accounting_id"
                  :value="account.accounting_id"
                  >{{
                    account.acc_code
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    account.name_th
                  }}</option
                >
              </select>
            </div>
            <p class="col-span-2">รหัสไปรษณีย์ :</p>
            <input
              class="col-span-4"
              v-model.number="doc_postcode"
              type="number"
              :disabled="sameAddress"
            />
            <p class="col-span-2">บัญชีที่รับเงิน :</p>
            <select
              tabindex="-1"
              class="col-span-4 w-10/12"
              v-model="selectedAccountName"
              @change="setCurrentBankPaymentName(selectedAccountName)"
              required
            >
              <option
                v-for="bank in accountNameList"
                :key="bank"
                :value="bank"
                >{{ bank }}</option
              >
            </select>
            <p class="col-span-2">หมายเหตุ :</p>
            <textarea
              rows="3"
              class="col-span-4 row-span-2"
              placeholder="หมายเหตุ"
              v-model="note"
            />
            <p class="col-span-2">ธนาคาร :</p>
            <select
              class="col-span-4 w-10/12"
              v-model="currentBank"
              required
              :disabled="selectedAccountName === ''"
            >
              <option
                v-for="bank in currentBankList"
                :key="bank.bankpayment_id"
                :value="{
                  bankpayment_id: bank.bankpayment_id,
                  bank: bank.bank,
                  acc_number: bank.acc_number,
                }"
              >
                {{
                  bank.bank
                }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                  bank.acc_number
                }}
              </option>
            </select>
          </div>
          <!-- <p>{{ selectedAccountName }}</p>
        <p>{{ currentBankList }}</p>
        <p>{{ currentBank }}</p> -->
        </div>
        <div class="grid grid-cols-10 gap-4">
          <vs-button
            class="col-end-10 mt-5 mb-8"
            color="#ffffff"
            text-color="#8d9498"
            @click="goBackPage"
          >
            ยกเลิก
          </vs-button>
          <vs-button
            class="col-end-11 mt-5 mb-8"
            button="submit"
            color="#15c1c3"
            :disabled="isLoading"
          >
            บันทึก
          </vs-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
export default {
  components: { Loading },
  data() {
    return {
      isLoading: false,
      successModal: false,
      successText: "",
      thaiProvince: [
        "กรุงเทพมหานคร",
        "สมุทรปราการ",
        "นนทบุรี",
        "ปทุมธานี",
        "พระนครศรีอยุธยา",
        "อ่างทอง",
        "ลพบุรี",
        "สิงห์บุรี",
        "ชัยนาท",
        "สระบุรี",
        "ชลบุรี",
        "ระยอง",
        "จันทบุรี",
        "ตราด",
        "ฉะเชิงเทรา",
        "ปราจีนบุรี",
        "นครนายก",
        "สระแก้ว",
        "นครราชสีมา",
        "บุรีรัมย์",
        "สุรินทร์",
        "ศรีสะเกษ",
        "อุบลราชธานี",
        "ยโสธร",
        "ชัยภูมิ",
        "อำนาจเจริญ",
        "หนองบัวลำภู",
        "ขอนแก่น",
        "อุดรธานี",
        "เลย",
        "หนองคาย",
        "มหาสารคาม",
        "ร้อยเอ็ด",
        "กาฬสินธุ์",
        "สกลนคร",
        "นครพนม",
        "มุกดาหาร",
        "เชียงใหม่",
        "ลำพูน",
        "ลำปาง",
        "อุตรดิตถ์",
        "แพร่",
        "น่าน",
        "พะเยา",
        "เชียงราย",
        "แม่ฮ่องสอน",
        "นครสวรรค์",
        "อุทัยธานี",
        "กำแพงเพชร",
        "ตาก",
        "สุโขทัย",
        "พิษณุโลก",
        "พิจิตร",
        "เพชรบูรณ์",
        "ราชบุรี",
        "กาญจนบุรี",
        "สุพรรณบุรี",
        "นครปฐม",
        "สมุทรสาคร",
        "สมุทรสงคราม",
        "เพชรบุรี",
        "ประจวบคีรีขันธ์",
        "นครศรีธรรมราช",
        "กระบี่",
        "พังงา",
        "ภูเก็ต",
        "สุราษฎร์ธานี",
        "ระนอง",
        "ชุมพร",
        "สงขลา",
        "สตูล",
        "ตรัง",
        "พัทลุง",
        "ปัตตานี",
        "ยะลา",
        "นราธิวาส",
        "บึงกาฬ",
      ],
      accountingList: [],
      bankPaymentList: [],
      company_name: "",
      company_code: "",
      tax_id: "",
      headquarter: "true",
      branch_code: null,
      branch_name: null,
      com_phone: "",
      com_email: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      address: "",
      district: "",
      subdistrict: "",
      province: "",
      postcode: null,
      sameAddress: true,
      doc_address: "",
      doc_district: "",
      doc_subdistrict: "",
      doc_province: "",
      doc_postcode: "",
      note: "",
      accounting_id: null,
      // bankpayment_id: null,
      selectedAccountName: "",
      currentBankList: [],
      currentBank: {},
    };
  },
  computed: {
    accountNameList() {
      const accountList = [];
      for (const account of this.bankPaymentList) {
        if (!accountList.includes(account.acc_name)) {
          accountList.push(account.acc_name);
        }
      }
      return accountList;
    },
  },
  watch: {
    headquarter() {
      if (this.headquarter === "true") {
        this.branch_code = null;
        this.branch_name = null;
      }
    },
    company_code() {
      this.company_code = this.company_code.toUpperCase();
    },
  },
  methods: {
    async setCurrentBankPaymentName() {
      const getBank = await axios.get(
        `${baseUrl}/bankpayment/get/?acc_name=${this.selectedAccountName}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(getBank);
      this.currentBankList = getBank.data.data;
    },
    goBackPage() {
      this.$router.go(-1);
    },
    async submitForm() {
      this.isLoading = true;
      const formData = {
        company_name: this.company_name,
        company_code: this.company_code,
        tax_id: this.tax_id,
        headquarter: this.headquarter === "true" ? true : false,
        branch_code: this.branch_code,
        branch_name: this.branch_name,
        com_phone: this.com_phone,
        com_email: this.com_email,
        contact_name: this.contact_name,
        contact_email: this.contact_email,
        contact_phone: this.contact_phone,
        address: this.address,
        district: this.district,
        subdistrict: this.subdistrict,
        province: this.province,
        postcode: this.postcode,
        sameAddress: this.sameAddress,
        doc_address:
          this.sameAddress === true ? this.address : this.doc_address,
        doc_district:
          this.sameAddress === true ? this.district : this.doc_district,
        doc_subdistrict:
          this.sameAddress === true ? this.subdistrict : this.doc_subdistrict,
        doc_province:
          this.sameAddress === true ? this.province : this.doc_province,
        doc_postcode:
          this.sameAddress === true ? this.postcode : this.doc_postcode,
        note: this.note === "" ? null : this.note,
        accounting_id: this.accounting_id,
        bankpayment_id: this.currentBank.bankpayment_id,
      };
      // console.log(JSON.stringify(formData));
      // console.log(JSON.parse(formData));
      // return;
      if (!this.$route.params.id) {
        try {
          const res = await axios.post(`${baseUrl}/register/member`, formData, {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          });
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "เพิ่มสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/managemember");
            }, 1000);
          } else {
            if (res.data.message === "username already registered") {
              const error = new Error("อีเมลบริษัทได้ถูกใช้ไปแล้ว");
              throw error;
            }
            if (res.data.message === "company_code already registered") {
              const error = new Error("รหัสบริษัทนี้ได้ถูกใช้ไปแล้ว");
              throw error;
            }
          }
        } catch (err) {
          alert(err);
        }
      } else {
        try {
          const res = await axios.post(
            `${baseUrl}/member/edit?detail_id=${this.$route.params.id}`,
            formData,
            {
              headers: {
                Authorization: this.$store.getters.getToken,
              },
            }
          );
          console.log(res);
          if (res.data.status === "success") {
            this.successText = "แก้ไขสำเร็จ";
            this.successModal = true;
            setTimeout(() => {
              this.successModal = false;
              this.$router.replace("/managemember");
            }, 1000);
          } else {
            const error = new Error("แก้ไขสมาชิกไม่สำเร็จ");
            throw error;
          }
        } catch (err) {
          alert(err);
        }
      }
      this.isLoading = false;
    },
    async loadData() {
      this.isLoading = true;
      const accounting = await axios.get(`${baseUrl}/accounting/get`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.accountingList = accounting.data.data;
      const bankPayment = await axios.get(`${baseUrl}/bankpayment/get/`, {
        headers: {
          Authorization: this.$store.getters.getToken,
        },
      });
      this.bankPaymentList = bankPayment.data.data;
      if (this.$route.params.id) {
        await this.loadMember();
      }
      this.isLoading = false;
    },
    async loadMember() {
      const res = await axios.get(
        `${baseUrl}/member/get?detail_id=${this.$route.params.id}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      const member = res.data.data;
      console.log(member);
      this.company_name = member.company_name;
      this.company_code = member.company_code;
      this.tax_id = member.tax_id;
      this.headquarter = member.headquarter.toString();
      this.branch_code = member.branch_code;
      this.branch_name = member.branch_name;
      this.com_phone = member.com_phone;
      this.com_email = member.com_email;
      this.contact_name = member.contact_name;
      this.contact_email = member.contact_email;
      this.contact_phone = member.contact_phone;
      this.address = member.address;
      this.district = member.district;
      this.subdistrict = member.subdistrict;
      this.province = member.province;
      this.postcode = member.postcode;
      this.sameAddress = member.sameAddress;
      this.doc_address = member.doc_address;
      this.doc_district = member.doc_district;
      this.doc_subdistrict = member.doc_subdistrict;
      this.doc_province = member.doc_province;
      this.doc_postcode = member.doc_postcode;
      this.note = member.note;
      this.accounting_id = member.accounting_id;
      this.bankpayment_id = member.bankpayment_id;
      this.selectedAccountName = member.bankpayment.acc_name;
      this.setCurrentBankPaymentName();
      this.currentBank = {
        bankpayment_id: member.bankpayment.bankpayment_id,
        bank: member.bankpayment.bank,
        acc_number: member.bankpayment.acc_number,
      };
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
h2 {
  color: #ffffff;
}

p {
  color: #ffffff;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 35px;
}

input[type="number"],
input[type="text"],
input[type="email"],
select,
textarea {
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

textarea {
  padding-top: 5px;
}

select,
input[type="number"],
input[type="text"],
input[type="email"] {
  height: 34px;
  min-width: 0;
}

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

input[type="text"]:disabled,
input[type="number"]:disabled,
textarea:disabled,
select:disabled {
  color: #999da6;
  background-color: #474c5c;
}
</style>
